import {CategoryInterface} from "../interfaces/catalog/CategoryInterface";
import {ProductInterface} from "../interfaces/product/ProductInterface";
import {stripBoldMarkers} from "./formatBoldText";

export interface PageSeoInterface {
    title: string
    description: string
}

const RUBLES_FORMAT = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});

// Intl ставит разделителем разрядов неразрывный пробел (U+00A0) — в title и meta-тегах
// нужен обычный, как в компоненте Money
const formatRubles = (rubles: number): string => RUBLES_FORMAT.format(rubles).replace(/\u00A0/g, ' ');

/**
 * Title и description карточки товара — по шаблонам карточки основного сайта.
 * Цена берётся розничная (current_price), а не client_price клиента.
 */
export function getProductSeo(product: ProductInterface): PageSeoInterface {
    const price = product.current_price?.amount ? formatRubles(product.current_price.amount / 100) : '';
    const pricePhrase = price ? ` за ${price} руб.` : '';
    const nameAndBrand = `${product.name} ${product.brand_name}`;

    return {
        title: `Купить ${nameAndBrand}${price ? `${pricePhrase} в магазине pride.ru` : ''}`,
        description: `Купить ${nameAndBrand}${pricePhrase} в магазине pride.ru: характеристики, фото, инструкция. Всегда выгодные цены!`
    };
}

/**
 * Title и description страницы категории — по шаблонам основного сайта.
 * minPrice приходит из priceFilter API уже в рублях, в отличие от amount цены товара.
 */
export function getCategorySeo(category: CategoryInterface, minPrice: number, brandNames: string[]): PageSeoInterface {
    const categoryName = stripBoldMarkers(category.full_name);
    const nameWithBrands = [categoryName, ...brandNames].join(' ');
    const price = minPrice ? formatRubles(minPrice) : '';

    return {
        title: `Купить ${nameWithBrands}${price ? ` от ${price} руб.` : ''} в магазине pride.ru`,
        description: `Купить ${nameWithBrands} по низким ценам. Акции и скидки на ${categoryName.toLowerCase()}`
    };
}
